"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var next_intl_1 = require("next-intl");
var ProviderIcon_1 = __importDefault(require("./ProviderIcon"));
var image_1 = __importDefault(require("next/image"));
var ProvidersSelect = function (_a) {
    var isProviderDropdownOpen = _a.isProviderDropdownOpen, onClickHandle = _a.onClickHandle;
    var t = (0, next_intl_1.useTranslations)('translation');
    var handleProviderLabelClick = (0, react_1.useCallback)(function () {
        onClickHandle();
    }, [onClickHandle]);
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, " ").concat(isProviderDropdownOpen ? styles_module_scss_1.default.active : ''), onClick: handleProviderLabelClick },
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.icon, " ").concat(isProviderDropdownOpen ? styles_module_scss_1.default.active : '') },
                react_1.default.createElement(ProviderIcon_1.default, null)),
            t('providers'),
            ' '),
        react_1.default.createElement(image_1.default, { className: "".concat(styles_module_scss_1.default.arrow, " ").concat(isProviderDropdownOpen ? styles_module_scss_1.default.open : ''), width: "14", height: "13", src: "/img/icons/arrow.svg", alt: "icon" })));
};
exports.default = ProvidersSelect;
